import React, { useState } from 'react'
import { Box, Drawer, Stack } from '@mui/material'
import AddAdapterButton from './AddAdapterButton'
import AdapterCardList from './AdapterCardList'
import AdapterForm from './AdapterForm'
import { useUpdateSamlProviderMutation } from '../../../../api/settings.api'
import { CloseDrawer } from '../../../../common/icons/closeDrawer'

export default function CustomProviders() {
  const [selectedAdapter, setSelectedAdapter] = useState(null)
  const [isConfigureOpen, setIsConfigureOpen] = useState(false)
  const [updateProvider] = useUpdateSamlProviderMutation()

  const handleConfigure = adapter => {
    setSelectedAdapter(adapter)
    setIsConfigureOpen(true)
  }

  const handleSubmit = async values => {
    try {
      await updateProvider({ id: selectedAdapter.id, ...values }).unwrap()
      setIsConfigureOpen(false)
    } catch (error) {
      console.error('Failed to update provider:', error)
    }
  }

  return (
    <Stack rowGap={3} component='section'>
      <Box display='flex' justifyContent='space-between' alignItems='center'>
        <h2>SAML 2.0 Adapters</h2>
        <AddAdapterButton />
      </Box>

      <AdapterCardList onConfigure={handleConfigure} />

      <Drawer anchor='right' open={isConfigureOpen} onClose={() => setIsConfigureOpen(false)}>
        <Stack
          sx={{
            padding: '32px',
            rowGap: 2
          }}
        >
          <Box display='flex' justifyContent='space-between' alignItems='center'>
            <h2>SAML 2.0 Configuration</h2>
            <div
              style={{
                position: 'fixed',
                top: '24px',
                right: '700px',
                cursor: 'pointer'
              }}
              onClick={() => {
                setIsConfigureOpen(false)
              }}
            >
              <CloseDrawer />
            </div>
          </Box>

          {selectedAdapter && (
            <AdapterForm adapter={selectedAdapter} onSubmit={handleSubmit} onClose={() => setIsConfigureOpen(false)} />
          )}
        </Stack>
      </Drawer>
    </Stack>
  )
}
